(() => {
  'use strict';

  /*
   * Înlocuiește URL-ul de mai jos cu URL-ul Worker-ului tău.
   */
  const BNR_ENDPOINT =
    'https://bnr-currency.mibo-services.workers.dev/';

  const PRICE_SELECTOR = '.bnr-eur-price';
  const CACHE_KEY = 'shopify_bnr_eur_rate';
  const CACHE_DURATION = 6 * 60 * 60 * 1000; // 6 ore

  let currentRate = null;
  let updateTimer = null;

  function getCachedRate() {
    try {
      const cached = JSON.parse(
        localStorage.getItem(CACHE_KEY) || 'null'
      );

      if (
        cached &&
        Number.isFinite(Number(cached.rate)) &&
        Date.now() - Number(cached.savedAt) < CACHE_DURATION
      ) {
        return Number(cached.rate);
      }
    } catch (error) {
      console.warn('BNR cache could not be read:', error);
    }

    return null;
  }

  function saveRate(rate, date) {
    try {
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({
          rate,
          date,
          savedAt: Date.now()
        })
      );
    } catch (error) {
      console.warn('BNR rate could not be cached:', error);
    }
  }

  async function getBnrRate() {
    const cachedRate = getCachedRate();

    if (cachedRate) {
      return cachedRate;
    }

    const response = await fetch(BNR_ENDPOINT, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`BNR endpoint error: ${response.status}`);
    }

    const data = await response.json();
    const rate = Number(data.rate);

    if (!Number.isFinite(rate) || rate <= 0) {
      throw new Error('Invalid BNR EUR rate');
    }

    saveRate(rate, data.date || null);

    return rate;
  }

  function formatEuro(value) {
    return new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function convertElement(element, rate) {
    const cents = Number(element.dataset.bnrPriceCents);

    if (!Number.isFinite(cents) || cents < 0) {
      element.textContent = '';
      return;
    }

    const ronPrice = cents / 100;
    const eurPrice = ronPrice / rate;

    element.textContent = ` (${formatEuro(eurPrice)})`;
    element.dataset.bnrProcessedPrice = String(cents);
    element.title = `Valoare orientativă, calculată la cursul BNR: 1 EUR = ${rate.toFixed(
      4
    )} RON`;
  }

  function updateAllPrices() {
    if (!currentRate) return;

    document.querySelectorAll(PRICE_SELECTOR).forEach((element) => {
      convertElement(element, currentRate);
    });
  }

  /*
   * Încearcă să identifice prețul variantei selectate din JSON-ul
   * disponibil în multe teme Shopify.
   */
  function updateProductVariantPrice(variant) {
    if (!variant || typeof variant.price === 'undefined') {
      return;
    }

    const productSection =
      document.querySelector(
        `[data-section-id="${variant.sectionId || ''}"]`
      ) ||
      document.querySelector('product-info') ||
      document;

    productSection
      .querySelectorAll(PRICE_SELECTOR)
      .forEach((element) => {
        element.dataset.bnrPriceCents = String(variant.price);

        if (currentRate) {
          convertElement(element, currentRate);
        }
      });
  }

  function watchPriceChanges() {
    const observer = new MutationObserver(() => {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(() => {
        updateAllPrices();
      }, 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindVariantEvents() {
    /*
     * Evenimente folosite de diferite versiuni și teme Shopify.
     */
    document.addEventListener('variant:change', (event) => {
      const variant =
        event.detail?.variant ||
        event.detail?.selectedVariant ||
        null;

      updateProductVariantPrice(variant);
    });

    document.addEventListener('product:variant-change', (event) => {
      const variant =
        event.detail?.variant ||
        event.detail?.selectedVariant ||
        null;

      updateProductVariantPrice(variant);
    });
  }

  async function init() {
    try {
      currentRate = await getBnrRate();
      updateAllPrices();
      watchPriceChanges();
      bindVariantEvents();
    } catch (error) {
      console.warn('EUR prices could not be displayed:', error);

      document.querySelectorAll(PRICE_SELECTOR).forEach((element) => {
        element.textContent = '';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();